"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _checkbox = _interopRequireDefault(require("element-ui/lib/checkbox"));

var _radio = _interopRequireDefault(require("element-ui/lib/radio"));

var _scrollbar = _interopRequireDefault(require("element-ui/lib/scrollbar"));

var _mousewheel = _interopRequireDefault(require("element-ui/lib/directives/mousewheel"));

var _locale = _interopRequireDefault(require("element-ui/lib/mixins/locale"));

var _migrating = _interopRequireDefault(require("element-ui/lib/mixins/migrating"));

var _resizeEvent = require("element-ui/lib/utils/resize-event");

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var _tableBody = _interopRequireDefault(require("./table-body"));

var _tableFooter = _interopRequireDefault(require("./table-footer"));

var _tableHeader = _interopRequireDefault(require("./table-header"));

var _tableLayout = _interopRequireDefault(require("./table-layout"));

var _tableStore = _interopRequireDefault(require("./table-store"));

/* eslint-disable vue/no-unused-components */
// import { addClass, removeClass } from 'element-ui/src/utils/dom'
var tableIdSeed = 1;

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    staticClass: "el-table",
    "class": [{
      'el-table--fit': _vm.fit,
      'el-table--striped': _vm.stripe,
      'el-table--border': _vm.border || _vm.isGroup,
      'el-table--hidden': _vm.isHidden,
      'el-table--group': _vm.isGroup,
      'el-table--fluid-height': _vm.maxHeight,
      'el-table--scrollable-x': _vm.layout.scrollX,
      'el-table--scrollable-y': _vm.layout.scrollY,
      'el-table--detail-page-highlight': _vm.detailPageHighlightCurrentRow,
      'el-table--special': _vm.special,
      'el-table--enable-row-hover': !_vm.store.states.isComplex,
      'el-table--enable-row-transition': (_vm.store.states.data || []).length !== 0 && (_vm.store.states.data || []).length < 100
    }, _vm.tableSize ? "el-table--" + _vm.tableSize : ''],
    attrs: {},
    on: {
      "mouseleave": function mouseleave($event) {
        _vm.handleMouseLeave($event);
      }
    }
  }, [_c('div', {
    ref: "hiddenColumns",
    staticClass: "hidden-columns",
    attrs: {}
  }, [_vm._t("default", null, {})], 2), _vm._v(" "), _vm.showHeader ? _c('div', {
    directives: [{
      name: "mousewheel",
      rawName: "v-mousewheel",
      value: _vm.handleHeaderFooterMousewheel,
      expression: "handleHeaderFooterMousewheel"
    }],
    ref: "headerWrapper",
    staticClass: "el-table__header-wrapper",
    attrs: {}
  }, [_c('table-header', {
    ref: "tableHeader",
    style: _vm._px2rem(_vm.headerStyle, 24, ['width']),
    attrs: {
      "store": _vm.store,
      "border": _vm.border,
      "default-sort": _vm.defaultSort,
      "conversionForbiddenPx2Rem": "width"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-scrollbar', {
    ref: "bodyWrapper",
    "class": ['el-table__body-wrapper', _vm.layout.scrollX ? "is-scrolling-" + _vm.scrollPosition : 'is-scrolling-none'],
    attrs: {
      "wrap-style": [_vm.bodyHeight]
    }
  }, [_c('table-body', {
    ref: "tableBody",
    style: _vm._px2rem(_vm.bodyStyle, 24, ['width']),
    attrs: {
      "context": _vm.context,
      "store": _vm.store,
      "stripe": _vm.stripe,
      "row-class-name": _vm.rowClassName,
      "row-style": _vm.rowStyle,
      "highlight": _vm.highlightCurrentRow,
      "conversionForbiddenPx2Rem": "width"
    }
  }), _vm._v(" "), !_vm.data || _vm.data.length === 0 ? _c('div', {
    ref: "emptyBlock",
    staticClass: "el-table__empty-block",
    style: _vm._px2rem(_vm.bodyStyle, 24, ['width']),
    attrs: {
      "conversionForbiddenPx2Rem": "width"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text",
    attrs: {}
  }, [_vm._t("empty", [_vm._v(_vm._s(_vm.emptyText || _vm.t('el.table.emptyText')))], {})], 2)]) : _vm._e(), _vm._v(" "), _vm.$slots.append ? _c('div', {
    ref: "appendWrapper",
    staticClass: "el-table__append-wrapper",
    attrs: {}
  }, [_vm._t("append", null, {})], 2) : _vm._e()], 1), _vm._v(" "), _vm.showSummary ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.data && _vm.data.length > 0,
      expression: "data && data.length > 0"
    }, {
      name: "mousewheel",
      rawName: "v-mousewheel",
      value: _vm.handleHeaderFooterMousewheel,
      expression: "handleHeaderFooterMousewheel"
    }],
    ref: "footerWrapper",
    staticClass: "el-table__footer-wrapper",
    attrs: {}
  }, [_c('table-footer', {
    style: _vm._px2rem(_vm.footerStyle, 24, ['width']),
    attrs: {
      "store": _vm.store,
      "border": _vm.border,
      "sum-text": _vm.sumText || _vm.t('el.table.sumText'),
      "summary-method": _vm.summaryMethod,
      "default-sort": _vm.defaultSort,
      "conversionForbiddenPx2Rem": "width"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.fixedColumns.length > 0 ? _c('div', {
    directives: [{
      name: "mousewheel",
      rawName: "v-mousewheel",
      value: _vm.handleFixedMousewheel,
      expression: "handleFixedMousewheel"
    }],
    ref: "fixedWrapper",
    staticClass: "el-table__fixed",
    style: [_vm._px2rem(_vm.fixedWrapperStyle, 24, ['width', 'bottom', 'height']), _vm._px2rem(_vm.fixedHeight, 24, ['width', 'bottom', 'height'])],
    attrs: {
      "conversionForbiddenPx2Rem": "width,bottom,height"
    }
  }, [_vm.showHeader ? _c('div', {
    ref: "fixedHeaderWrapper",
    staticClass: "el-table__fixed-header-wrapper",
    attrs: {}
  }, [_c('table-header', {
    ref: "fixedTableHeader",
    style: _vm._px2rem(_vm.bodyStyle, 24, ['width']),
    attrs: {
      "fixed": "left",
      "border": _vm.border,
      "store": _vm.store,
      "conversionForbiddenPx2Rem": "width"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "fixedBodyWrapper",
    staticClass: "el-table__fixed-body-wrapper",
    style: [_vm._px2rem(_vm.rightFixedBodyWrapperStyle, 24, ['top', 'max-height', 'height']), _vm._px2rem(_vm.fixedBodyHeight, 24, ['top', 'max-height', 'height'])],
    attrs: {
      "conversionForbiddenPx2Rem": "top,max-height,height"
    }
  }, [_c('table-body', {
    style: _vm._px2rem(_vm.bodyStyle, 24, ['width']),
    attrs: {
      "fixed": "left",
      "store": _vm.store,
      "stripe": _vm.stripe,
      "highlight": _vm.highlightCurrentRow,
      "row-class-name": _vm.rowClassName,
      "row-style": _vm.rowStyle,
      "conversionForbiddenPx2Rem": "width"
    }
  }), _vm._v(" "), _vm.$slots.append ? _c('div', {
    staticClass: "el-table__append-gutter",
    style: {
      height: _vm._px2rem(_vm.layout.appendHeight + 'px', 24, [])
    },
    attrs: {}
  }) : _vm._e()], 1), _vm._v(" "), _vm.showSummary ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.data && _vm.data.length > 0,
      expression: "data && data.length > 0"
    }],
    ref: "fixedFooterWrapper",
    staticClass: "el-table__fixed-footer-wrapper",
    attrs: {}
  }, [_c('table-footer', {
    style: _vm._px2rem(_vm.bodyStyle, 24, ['width']),
    attrs: {
      "fixed": "left",
      "border": _vm.border,
      "sum-text": _vm.sumText || _vm.t('el.table.sumText'),
      "summary-method": _vm.summaryMethod,
      "store": _vm.store,
      "conversionForbiddenPx2Rem": "width"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.rightFixedColumns.length > 0 ? _c('div', {
    directives: [{
      name: "mousewheel",
      rawName: "v-mousewheel",
      value: _vm.handleFixedMousewheel,
      expression: "handleFixedMousewheel"
    }],
    ref: "rightFixedWrapper",
    staticClass: "el-table__fixed-right",
    style: [_vm._px2rem(_vm.rightFixedWrapperStyle, 24, ['right', 'width', 'bottom', 'height']), _vm._px2rem(_vm.fixedHeight, 24, ['right', 'width', 'bottom', 'height'])],
    attrs: {
      "conversionForbiddenPx2Rem": "right,width,bottom,height"
    }
  }, [_vm.showHeader ? _c('div', {
    ref: "rightFixedHeaderWrapper",
    staticClass: "el-table__fixed-header-wrapper",
    attrs: {}
  }, [_c('table-header', {
    ref: "rightFixedTableHeader",
    style: _vm._px2rem(_vm.bodyStyle, 24, ['width']),
    attrs: {
      "fixed": "right",
      "border": _vm.border,
      "store": _vm.store,
      "conversionForbiddenPx2Rem": "width"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "rightFixedBodyWrapper",
    staticClass: "el-table__fixed-body-wrapper",
    style: [_vm._px2rem(_vm.rightFixedBodyWrapperStyle, 24, ['top', 'max-height', 'height']), _vm._px2rem(_vm.fixedBodyHeight, 24, ['top', 'max-height', 'height'])],
    attrs: {
      "conversionForbiddenPx2Rem": "top,max-height,height"
    }
  }, [_c('table-body', {
    style: _vm._px2rem(_vm.bodyStyle, 24, ['width']),
    attrs: {
      "fixed": "right",
      "store": _vm.store,
      "stripe": _vm.stripe,
      "row-class-name": _vm.rowClassName,
      "row-style": _vm.rowStyle,
      "highlight": _vm.highlightCurrentRow,
      "conversionForbiddenPx2Rem": "width"
    }
  })], 1), _vm._v(" "), _vm.showSummary ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.data && _vm.data.length > 0,
      expression: "data && data.length > 0"
    }],
    ref: "rightFixedFooterWrapper",
    staticClass: "el-table__fixed-footer-wrapper",
    attrs: {}
  }, [_c('table-footer', {
    style: _vm._px2rem(_vm.bodyStyle, 24, ['width']),
    attrs: {
      "fixed": "right",
      "border": _vm.border,
      "sum-text": _vm.sumText || _vm.t('el.table.sumText'),
      "summary-method": _vm.summaryMethod,
      "store": _vm.store,
      "conversionForbiddenPx2Rem": "width"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.rightFixedColumns.length > 0 ? _c('div', {
    ref: "rightFixedPatch",
    staticClass: "el-table__fixed-right-patch",
    style: _vm._px2rem(_vm.rightFixedPatchStyle, 24, ['width', 'height']),
    attrs: {
      "conversionForbiddenPx2Rem": "width,height"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.resizeProxyVisible,
      expression: "resizeProxyVisible"
    }],
    ref: "resizeProxy",
    staticClass: "el-table__column-resize-proxy",
    attrs: {}
  })], 1);
};

var __vue_staticRenderFns__ = [];
var _default2 = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElTable',
  mixins: [_locale["default"], _migrating["default"]],
  directives: {
    Mousewheel: _mousewheel["default"]
  },
  props: {
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    size: String,
    width: [String, Number],
    height: [String, Number],
    maxHeight: [String, Number],
    fit: {
      type: Boolean,
      "default": true
    },
    stripe: Boolean,
    border: Boolean,
    rowKey: [String, Function],
    context: {},
    showHeader: {
      type: Boolean,
      "default": true
    },
    showSummary: Boolean,
    sumText: String,
    summaryMethod: Function,
    rowClassName: [String, Function],
    rowStyle: [Object, Function],
    cellClassName: [String, Function],
    cellStyle: [Object, Function],
    headerRowClassName: [String, Function],
    headerRowStyle: [Object, Function],
    headerCellClassName: [String, Function],
    headerCellStyle: [Object, Function],
    highlightCurrentRow: Boolean,
    currentRowKey: [String, Number],
    emptyText: String,
    expandRowKeys: Array,
    defaultExpandAll: Boolean,
    defaultSort: Object,
    tooltipEffect: String,
    spanMethod: Function,
    selectOnIndeterminate: {
      type: Boolean,
      "default": true
    },

    /** 扩展 右键菜单 */
    menus: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    columnDragSortable: {
      type: Boolean,
      "default": true
    },
    detailPageHighlightCurrentRow: Boolean,
    showOverflowTooltip: Boolean,
    special: Boolean,
    // skyEngine 2版本表格样式做了调整
    selectIds: {
      type: Array,
      "default": function _default() {
        return [];
      }
    }
    /** */

  },
  components: {
    TableHeader: _tableHeader["default"],
    TableFooter: _tableFooter["default"],
    TableBody: _tableBody["default"],
    ElCheckbox: _checkbox["default"],
    ElRadio: _radio["default"],
    ElScrollbar: _scrollbar["default"]
  },
  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        events: {
          expand: 'expand is renamed to expand-change'
        }
      };
    },
    setCurrentRow: function setCurrentRow(row) {
      this.store.commit('setCurrentRow', row);
    },
    toggleRowSelection: function toggleRowSelection(row, selected) {
      this.store.toggleRowSelection(row, selected);
      this.store.updateAllSelected();
    },
    toggleRowChecked: function toggleRowChecked(row, checked) {
      this.store.toggleRowChecked(row, checked);
    },
    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
      this.store.toggleRowExpansion(row, expanded);
    },
    clearSelection: function clearSelection() {
      this.store.clearSelection();
    },
    clearFilter: function clearFilter() {
      this.store.clearFilter();
    },
    clearSort: function clearSort() {
      this.store.clearSort();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.store.commit('setHoverRow', null);
      if (this.hoverState) this.hoverState = null;
    },
    updateScrollY: function updateScrollY() {
      this.layout.updateScrollY();
      this.layout.updateColumnsWidth();
    },
    handleFixedMousewheel: function handleFixedMousewheel(event, data) {
      var bodyWrapper = this.bodyWrapper;

      if (Math.abs(data.spinY) > 0) {
        var currentScrollTop = bodyWrapper.scrollTop;

        if (data.pixelY < 0 && currentScrollTop !== 0) {
          event.preventDefault();
        }

        if (data.pixelY > 0 && bodyWrapper.scrollHeight - bodyWrapper.clientHeight > currentScrollTop) {
          event.preventDefault();
        }

        bodyWrapper.scrollTop += Math.ceil(data.pixelY / 5);
      } else {
        bodyWrapper.scrollLeft += Math.ceil(data.pixelX / 5);
      }
    },
    handleHeaderFooterMousewheel: function handleHeaderFooterMousewheel(event, data) {
      var pixelX = data.pixelX,
          pixelY = data.pixelY;

      if (Math.abs(pixelX) >= Math.abs(pixelY)) {
        event.preventDefault();
        this.bodyWrapper.scrollLeft += data.pixelX / 5;
      }
    },
    bindEvents: function bindEvents() {
      var _this$$refs = this.$refs,
          headerWrapper = _this$$refs.headerWrapper,
          footerWrapper = _this$$refs.footerWrapper;
      var refs = this.$refs;
      var self = this;
      this.bodyWrapper.addEventListener('scroll', function () {
        if (headerWrapper) headerWrapper.scrollLeft = this.scrollLeft;
        if (footerWrapper) footerWrapper.scrollLeft = this.scrollLeft;
        if (refs.fixedBodyWrapper) refs.fixedBodyWrapper.scrollTop = this.scrollTop;
        if (refs.rightFixedBodyWrapper) refs.rightFixedBodyWrapper.scrollTop = this.scrollTop;
        var maxScrollLeftPosition = this.scrollWidth - this.offsetWidth - 1;
        var scrollLeft = this.scrollLeft;

        if (scrollLeft >= maxScrollLeftPosition) {
          self.scrollPosition = 'right';
        } else if (scrollLeft === 0) {
          self.scrollPosition = 'left';
        } else {
          self.scrollPosition = 'middle';
        }

        if (self.$refs.tableBody && self.$refs.tableBody.menuPanel) {
          self.$refs.tableBody.menuPanel.showPopper = false; // 当滚动的时候，关闭菜单
        }

        var tooltip = self.$refs.tableBody.$refs.tooltip;

        if (tooltip) {
          // 当滚动的时候，关闭tooltip
          tooltip.setExpectedState(false);
          tooltip.handleClosePopper();
        }
      });

      if (this.fit) {
        (0, _resizeEvent.addResizeListener)(this.$el, this.resizeListener);
      }
    },
    resizeListener: function resizeListener() {
      var _this = this;

      if (!this.$ready) return;
      var shouldUpdateLayout = false;
      var el = this.$el;
      var _this$resizeState = this.resizeState,
          oldWidth = _this$resizeState.width,
          oldHeight = _this$resizeState.height;
      var width = el.offsetWidth;

      if (oldWidth !== width) {
        shouldUpdateLayout = true;
      }

      var height = el.offsetHeight;

      if ((this.height || this.shouldUpdateHeight) && oldHeight !== height) {
        shouldUpdateLayout = true;
      }

      if (shouldUpdateLayout) {
        this.resizeState.width = width;
        this.resizeState.height = height;
        this.doLayout();
      } // 扩展


      this.$nextTick(function () {
        _this.updateScroll();
      });
    },
    doLayout: function doLayout() {
      this.layout.updateColumnsWidth();

      if (this.shouldUpdateHeight) {
        this.layout.updateElsHeight();
      }
    },
    sort: function sort(prop, order) {
      this.store.commit('sort', {
        prop: prop,
        order: order
      });
    },
    toggleAllSelection: function toggleAllSelection() {
      this.store.commit('toggleAllSelection');
    },
    // 扩展
    updateScroll: function updateScroll() {
      this.$refs.bodyWrapper && this.$refs.bodyWrapper.update();
    },
    // 当点击详情，隐藏字段
    hiddenColumnOnShowDetailPage: function hiddenColumnOnShowDetailPage() {
      var _this2 = this;

      var isHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var columns = this.store.states._columns;
      var index = columns.findIndex(function (d) {
        return d.type === 'index' || d.type === 'selection' || d.type === 'radio';
      });
      index = index + 1;

      for (var i = index; i < columns.length; i++) {
        if (isHidden) {
          columns[i].backWidth = columns[i].width;
          columns[i].backShowOverflowTooltip = columns[i].showOverflowTooltip;

          if (i === index) {
            columns[i].width = null;
            columns[i].showOverflowTooltip = false;
          } else {
            columns[i].width = 1;
          }
        } else {
          columns[i].width = columns[i].backWidth;
          columns[i].showOverflowTooltip = columns[i].backShowOverflowTooltip;
        }
      } // index = index + 2;
      // const slice = [].slice;
      // const headerThs = slice.call(this.$refs.tableHeader.$el.querySelectorAll(`tr > th:nth-child(n + ${index})`), 0);
      // const bodyTds = slice.call(this.$refs.tableBody.$el.querySelectorAll(`tr > td:nth-child(n + ${index})`), 0);
      // const allTds = headerThs.concat(bodyTds);
      // for (let i = 0; i < allTds.length; i++) {
      //   const td = allTds[i];
      //   isHidden ? addClass(td, 'is-noshow') : removeClass(td, 'is-noshow');
      // }
      // 清除当前列，避免非拖动表头时，调整宽度后的计算出现问题，如link的点击事件、打开FullDialog。


      this.store.setCurrentCol(null);
      this.doLayout();
      this.$nextTick(function () {
        _this2.updateScroll();
      });
    },
    // 扩展 获取当前选中的行
    getSelectItems: function getSelectItems() {
      var isSelected = this.store.states.selection.length > 0;
      return isSelected ? this.store.states.selection : this.store.states.checked ? [this.store.states.checked] : [];
    }
  },
  created: function created() {
    var _this3 = this;

    this.tableId = 'el-table_' + tableIdSeed++;
    this.debouncedUpdateLayout = (0, _debounce["default"])(50, function () {
      return _this3.doLayout();
    });
  },
  computed: {
    tableSize: function tableSize() {
      return this.size || (this.$ELEMENT || {}).size;
    },
    bodyWrapper: function bodyWrapper() {
      // 扩展 控制自定义滚动条
      // return this.$refs.bodyWrapper;
      return this.$refs.bodyWrapper.$el.querySelector('.el-scrollbar__wrap');
    },
    shouldUpdateHeight: function shouldUpdateHeight() {
      return this.height || this.maxHeight || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
    },
    selection: function selection() {
      return this.store.states.selection;
    },
    columns: function columns() {
      return this.store.states.columns;
    },
    tableData: function tableData() {
      return this.store.states.data;
    },
    fixedColumns: function fixedColumns() {
      return this.store.states.fixedColumns;
    },
    rightFixedPatchStyle: function rightFixedPatchStyle() {
      var layout = this.layout;
      return {
        width: layout.scrollY ? layout.gutterWidth + 'px' : '0',
        height: layout.headerHeight + 'px'
      };
    },
    rightFixedWrapperStyle: function rightFixedWrapperStyle() {
      var layout = this.layout;
      var border = this.border;
      return {
        width: layout.rightFixedWidth ? layout.rightFixedWidth + 'px' : '',
        right: layout.scrollY ? (border ? layout.gutterWidth : layout.gutterWidth || 0) + 'px' : ''
      };
    },
    rightFixedColumns: function rightFixedColumns() {
      return this.store.states.rightFixedColumns;
    },
    bodyStyle: function bodyStyle() {
      return {
        width: this.bodyWidth
      };
    },
    rightFixedBodyWrapperStyle: function rightFixedBodyWrapperStyle() {
      return {
        top: this.layout.headerHeight + 'px'
      };
    },
    footerStyle: function footerStyle() {
      var bodyWidth = this.layout.bodyWidth;
      return {
        width: bodyWidth ? bodyWidth + 'px' : ''
      };
    },
    headerStyle: function headerStyle() {
      var bodyWidth = this.layout.bodyWidth;
      return {
        width: bodyWidth ? bodyWidth + 'px' : ''
      };
    },
    fixedWrapperStyle: function fixedWrapperStyle() {
      return {
        width: this.layout.fixedWidth ? this.layout.fixedWidth + 'px' : ''
      };
    },
    bodyWidth: function bodyWidth() {
      var _this$layout = this.layout,
          bodyWidth = _this$layout.bodyWidth,
          scrollY = _this$layout.scrollY,
          gutterWidth = _this$layout.gutterWidth;
      return bodyWidth ? bodyWidth - (scrollY ? gutterWidth : 0) + 'px' : '';
    },
    bodyHeight: function bodyHeight() {
      if (this.height) {
        return {
          height: this.layout.bodyHeight ? this.layout.bodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        return {
          'max-height': (this.showHeader ? this.maxHeight - this.layout.headerHeight - this.layout.footerHeight : this.maxHeight - this.layout.footerHeight) + 'px'
        };
      }

      return {};
    },
    fixedBodyHeight: function fixedBodyHeight() {
      if (this.height) {
        return {
          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        var maxHeight = this.layout.scrollX ? this.maxHeight - this.layout.gutterWidth : this.maxHeight;

        if (this.showHeader) {
          maxHeight -= this.layout.headerHeight;
        }

        maxHeight -= this.layout.footerHeight;
        return {
          'max-height': maxHeight + 'px'
        };
      }

      return {};
    },
    fixedHeight: function fixedHeight() {
      if (this.maxHeight) {
        if (this.showSummary) {
          return {
            bottom: 0
          };
        }

        return {
          bottom: this.layout.scrollX && this.data.length ? this.layout.gutterWidth + 'px' : ''
        };
      } else {
        if (this.showSummary) {
          return {
            height: this.layout.tableHeight ? this.layout.tableHeight + 'px' : ''
          };
        }

        return {
          height: this.layout.viewportHeight ? this.layout.viewportHeight + 'px' : ''
        };
      }
    },
    tableType: function tableType() {
      return this.store.states.columns[0].type || 'normal';
    }
  },
  watch: {
    height: {
      immediate: true,
      handler: function handler(value) {
        this.layout.setHeight(value);
      }
    },
    maxHeight: {
      immediate: true,
      handler: function handler(value) {
        this.layout.setMaxHeight(value);
      }
    },
    currentRowKey: function currentRowKey(newVal) {
      this.store.setCurrentRowKey(newVal);
    },
    data: {
      immediate: true,
      handler: function handler(value) {
        var _this4 = this;

        this.store.commit('setData', value);

        if (this.$ready) {
          this.$nextTick(function () {
            _this4.doLayout(); // 扩展selectIds


            var tableType = _this4.tableType;
            if (tableType === 'normal' || !(_this4.selectIds && _this4.selectIds.length > 0)) return;

            _this4.selectIds.forEach(function (id) {
              for (var i = 0, length = _this4.data.length; i < length; i++) {
                if (_this4.data[i].id === id) {
                  if (tableType === 'selection') {
                    _this4.toggleRowSelection(_this4.data[i], true);
                  } else if (tableType === 'radio') {
                    // this.store.commit('rowCheckedChanged', this.data[i]);
                    _this4.toggleRowChecked(_this4.data[i], true);
                  } else if (tableType === 'expand') {
                    _this4.toggleRowExpansion(_this4.data[i], true);
                  }

                  break;
                }
              }
            });
          });
        }
      }
    },
    expandRowKeys: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.store.setExpandRowKeys(newVal);
        }
      }
    }
  },
  destroyed: function destroyed() {
    if (this.resizeListener) (0, _resizeEvent.removeResizeListener)(this.$el, this.resizeListener);
  },
  mounted: function mounted() {
    var _this5 = this;

    this.bindEvents();
    this.store.updateColumns();
    this.doLayout();
    this.resizeState = {
      width: this.$el.offsetWidth,
      height: this.$el.offsetHeight
    }; // init filters

    this.store.states.columns.forEach(function (column) {
      if (column.filteredValue && column.filteredValue.length) {
        _this5.store.commit('filterChange', {
          column: column,
          values: column.filteredValue,
          silent: true
        });
      }
    });
    this.$ready = true;
  },
  data: function data() {
    var store = new _tableStore["default"](this, {
      rowKey: this.rowKey,
      defaultExpandAll: this.defaultExpandAll,
      selectOnIndeterminate: this.selectOnIndeterminate
    });
    var layout = new _tableLayout["default"]({
      store: store,
      table: this,
      fit: this.fit,
      showHeader: this.showHeader
    });
    return {
      layout: layout,
      store: store,
      isHidden: false,
      renderExpanded: null,
      resizeProxyVisible: false,
      resizeState: {
        width: null,
        height: null
      },
      // 是否拥有多级表头
      isGroup: false,
      scrollPosition: 'left'
    };
  }
};
exports["default"] = _default2;